import React from 'react';
import { Table } from 'semantic-ui-react';
import type { CommunicationData } from 'types';

import ZoomRow from './zoomRow';

type _ZoomCommunication = {
  extension?: Array<{
    url: string;
    valueString?: string;
  }>;
  id: string;
  identifier?: Array<{
    system: string;
    value: string;
  }>;
  medium?: Array<{
    coding?: Array<{
      code: string;
      display: string;
      system: string;
    }>;
    text: string;
  }>;
  note?: Array<{ text: string; time?: string }>;
  received?: string;
  sender?: {
    display?: string;
  };
  status?: string;
  topic?: { text: string };
  [key: string]: unknown;
};

type ZoomTableProps = {
  debugCommunications: CommunicationData; //clean up with type TODO
  communicationsMutate: () => Promise<CommunicationData | undefined>;
  handleErrorMessage: (errorMessage: string) => void;
};

const ZoomTable: React.FC<ZoomTableProps> = ({ debugCommunications, communicationsMutate, handleErrorMessage }) => {
  return (
    <div className="table-div">
      <Table sortable celled singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Engagement ID</Table.HeaderCell>
            <Table.HeaderCell>User</Table.HeaderCell>
            <Table.HeaderCell>Direction</Table.HeaderCell>
            <Table.HeaderCell>Channel Type</Table.HeaderCell>
            <Table.HeaderCell>Content</Table.HeaderCell>
            <Table.HeaderCell>Start Time</Table.HeaderCell>
            <Table.HeaderCell>End Time</Table.HeaderCell>
            <Table.HeaderCell>Assign Member</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {debugCommunications.entry.map((communication, index) => (
            <ZoomRow
              key={index}
              debugCommunication={communication.resource}
              communicationsMutate={communicationsMutate}
              handleErrorMessage={handleErrorMessage}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default ZoomTable;
